import api from './api';

/**
 * Fetches the HD/original quality image URL for a given image ID
 * @param imageId - The ID of the image
 * @returns Promise<string> - The HD image URL
 */
export default async function getHdImageUrl(imageId: string): Promise<string> {
  try {
    const response = await api.get(`/image-generation/v1/images/${imageId}?mode=original`);
    return response.data.url;
  } catch (error) {
    console.error('Error fetching HD image URL:', error);
    throw error;
  }
}
